import { render, staticRenderFns } from "./AnnualReports.vue?vue&type=template&id=9d780cc0&scoped=true&"
import script from "./AnnualReports.vue?vue&type=script&lang=js&"
export * from "./AnnualReports.vue?vue&type=script&lang=js&"
import style0 from "./AnnualReports.vue?vue&type=style&index=0&id=9d780cc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d780cc0",
  null
  
)

export default component.exports